"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildVideoPlayerListener = void 0;
var events = [];
var buildVideoPlayerListener = function () { return ({
    on: function (cb) {
        events.push(cb);
    },
    off: function (cb) {
        var index = events.indexOf(cb);
        if (index !== -1) {
            events.splice(index, 1);
        }
    },
    trigger: function (eventName, eventPayload) {
        events.forEach(function (cb) { return cb(eventName, eventPayload); });
    },
}); };
exports.buildVideoPlayerListener = buildVideoPlayerListener;
